<script setup lang="ts">
const isExpanded = defineModel<boolean>({ default: true })

function toggle() {
  isExpanded.value = !isExpanded.value
}

defineExpose({ toggle })
</script>

<template>
  <v-layout-card v-bind="$attrs">
    <v-row
      justify="space-between"
      align="center"
      class="ma-0 pa-0"
      density="comfortable"
      no-gutters
    >
      <v-col cols="auto">
        <slot name="title"></slot>
      </v-col>
      <v-col cols="auto">
        <v-btn
          :icon="isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          rounded="circle"
          variant="outlined"
          size="small"
          @click="toggle"
        ></v-btn>
      </v-col>
    </v-row>
    <v-expand-transition mode="in-out">
      <div
        v-if="isExpanded"
        class="pt-2"
      >
        <slot name="text"></slot>
      </div>
    </v-expand-transition>
    <v-row
      v-if="!isExpanded"
      justify="center"
      class="ma-0 pa-0"
      density="comfortable"
      no-gutters
    >
      <v-col cols="auto">
        <v-btn
          append-icon="mdi-arrow-expand-vertical"
          variant="tonal"
          color="primary"
          rounded="pill"
          @click="toggle"
          >{{ $t('general_interface.buttons.expand') }}</v-btn
        >
      </v-col>
    </v-row>
  </v-layout-card>
</template>

<style scoped></style>
